import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import ErrorMessage from "../Helpers/ErrorMessage";
import API from "../Context/api";
import { v4 as uuidv4 } from "uuid"; // Import UUID for unique ChangeHistoryID

const AddComputerForm = ({ setIsModalOpen, onComputerAdded }) => {
  // Authentication context
  const { user } = useAuth();
  const createdBy = user?.name || "";
  console.log(createdBy);

  // State declarations
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [technicians, setTechnicians] = useState([]);

  // Initial form values to compare against
  const initialFormData = {
    name: "",
    serialNumber: "",
    make: "",
    model: "",
    client: "",
    resourceAssigned: "",
    repairStatusType: "In Repair",
    problemDescription: "",
    repairStatusDate: new Date().toISOString(),
    companyAssetTag: "",
    repairHistory: [],
    changeHistory: [],
    repairDetails: "",
    createdBy,
  };
  const [formData, setFormData] = useState(initialFormData);

  // Computer make options
  const computerMakes = [
    "Dell",
    "HP",
    "Lenovo",
    "Asus",
    "Acer",
    "Apple",
    "MSI",
  ];

  // Validate required fields

  const requiredFields = [
    "name",
    "serialNumber",
    "model",
    "make",
    "client",
    "companyAssetTag",
    "resourceAssigned",
    "createdBy",
    "problemDescription",
  ];

  const isFormValid = requiredFields.every((field) => formData[field]?.trim());

  // Fetch technicians on mount
  useEffect(() => {
    const fetchTechnicians = async () => {
      try {
        const response = await API.get("/users/role");
        setTechnicians(response.data);
      } catch (error) {
        console.error("Error fetching technicians:", error);
        setErrorMessage("Failed to load technicians");
      }
    };
    fetchTechnicians();
  }, []);

  // Handle form input changes and track changes
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // // Handle form submission
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Validate form
  //   const missingFields = requiredFields.filter(
  //     (field) => !formData[field]?.trim()
  //   );

  //   if (missingFields.length > 0) {
  //     setErrorMessage(
  //       `Please fill in required fields: ${missingFields.join(", ")}`
  //     );
  //     return;
  //   }

  //   // // Prepare submission data
  //   // const submissionData = {
  //   //   ...formData,
  //   //   repairDetails:
  //   //     formData.resourceAssigned || formData.repairStatusType
  //   //       ? [
  //   //           {
  //   //             resourceAssigned: formData.resourceAssigned,
  //   //             status: formData.repairStatusType,
  //   //             date: formData.repairStatusDate,
  //   //             companyAssetTag: formData.companyAssetTag,
  //   //             repairDetails: "",
  //   //             recommendations: "",
  //   //           },
  //   //         ]
  //   //       : [],
  //   // };
  //   // Prepare submission data
  //   const submissionData = {
  //     ...formData,
  //     repairDetails: {
  //       resourceAssigned: formData.resourceAssigned,
  //       status: formData.repairStatusType,
  //       date: formData.repairStatusDate,
  //       companyAssetTag: formData.companyAssetTag,
  //       repairDetails: "",
  //       recommendations: "",
  //     },
  //   };

  //   setIsLoading(true);
  //   try {
  //     let taskId = "";
  //     if (formData.resourceAssigned) {
  //       const technician = technicians.find(
  //         (t) => t.name === formData.resourceAssigned
  //       );

  //       if (technician) {
  //         const taskData = {
  //           userId: technician.userId,
  //           title: `Repair Computer: ${formData.name}`,
  //           description: `Serial Number: ${formData.serialNumber}\nClient: ${formData.client}`,
  //           status: formData.repairStatusType,
  //         };
  //         const taskResponse = await API.post("/users/tasks", taskData);
  //         taskId = taskResponse.data.taskId;
  //       }
  //     }

  //     if (taskId) {
  //       submissionData.taskId = taskId;
  //     }

  //     // Call backend
  //     await API.post("/computers", submissionData);
  //     setIsModalOpen(false);
  //     if (onComputerAdded) {
  //       onComputerAdded();
  //     }
  //   } catch (error) {
  //     const errorMsg =
  //       error.response?.data?.message || "Failed to add computer";
  //     setErrorMessage(errorMsg);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    const missingFields = requiredFields.filter(
      (field) => !formData[field]?.trim()
    );

    if (missingFields.length > 0) {
      setErrorMessage(
        `Please fill in required fields: ${missingFields.join(", ")}`
      );
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      // Track change history
      let updatedChangeHistory = [...formData.changeHistory];
      const fieldsToTrack = [
        "name",
        "serialNumber",
        "model",
        "make",
        "client",
        "resourceAssigned",
        "repairStatusType",
        "companyAssetTag",
        "problemDescription",
      ];

      const inventoryTrackingString = `INV-${Date.now()}`;

      fieldsToTrack.forEach((field) => {
        const oldValue = initialFormData[field] ?? "";
        const newValue = formData[field] ?? "";
        if (String(oldValue) !== String(newValue)) {
          console.log(
            "Creating change history for field:",
            field,
            "with ChangedBy:",
            createdBy
          ); // Debug log

          updatedChangeHistory.push({
            Title: `${field} updated`,
            Date: new Date().toISOString(),
            ChangeHistoryID: `${field}-${Date.now()}-${uuidv4()}`,
            ComputerID: uuidv4(),
            ChangedBy: createdBy,
            Field: field,
            OldValue: oldValue,
            NewValue: newValue,
          });
        }
      });

      // Create task first and retrieve taskId
      let taskId = "";
      if (formData.resourceAssigned) {
        const technician = technicians.find(
          (t) => t.name === formData.resourceAssigned
        );

        if (technician) {
          const taskData = {
            Title: `Repair Computer: ${formData.name} ${inventoryTrackingString}`,
            AssignedTo: technician.userId,
            AssignedToName: createdBy,
            // Description: `Serial Number: ${formData.serialNumber}\nClient: ${formData.client}`,
            Description: formData.problemDescription,
            Status: formData.repairStatusType,
            CreatedBy: createdBy,
            DateAssigned: new Date().toISOString(),
          };

          const taskResponse = await API.post("/tasks", taskData);
          taskId = taskResponse.data.taskId; // Make sure your backend returns `taskId`
        }
      }

      // 3️⃣ Prepare data for computer, repair, and history
      const computerId = uuidv4(); // or use a real one from elsewhere

      const fields = {
        Title: `Asset - ${formData.name}`,
        ComputerID: computerId,
        Name: formData.name,
        Client: formData.client,
        Model: formData.model,
        SerialNumber: formData.serialNumber,
        InventoryTrackingNumber: inventoryTrackingString,
        Make: formData.make,
        CompanyAssetTag: formData.companyAssetTag,
        IsFaulty: true,
        IsRepaired: false,
        CreatedBy: createdBy,
        TaskID: taskId,
      };

      const repairDetails = {
        Title: `Repair - ${formData.name}`,
        ComputerID: computerId,
        ProblemDescription: formData.problemDescription,
        ResourceAssigned: formData.resourceAssigned,
        RepairDetails: formData.repairDetails || "",
        Status: formData.repairStatusType,
        Date: new Date().toISOString(),
        Recommendations: formData.recommendations || "",
        CompanyAssetTag: formData.companyAssetTag,
        RepairID: uuidv4(),
      };

      const repairHistory = [];

      const submissionData = {
        fields,
        repairDetails,
        changeHistory: updatedChangeHistory,
        repairHistory,
      };

      // 4️⃣ Submit full computer + repair + history
      await API.post("/computers", submissionData);
      setFormData(initialFormData);
      setIsModalOpen(false);
      if (onComputerAdded) {
        onComputerAdded();
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to submit the form";
      setErrorMessage(errorMsg);
      // console.log(error);
    } finally {
      setIsLoading(false);
    }

    // let updatedChangeHistory = [...formData.changeHistory];

    // const fieldsToTrack = [
    //   "name",
    //   "serialNumber",
    //   "model",
    //   "make",
    //   "client",
    //   "resourceAssigned",
    //   "repairStatusType",
    //   "companyAssetTag",
    //   "problemDescription",
    // ];

    // fieldsToTrack.forEach((field) => {
    //   const oldValue = initialFormData[field] ?? "";
    //   const newValue = formData[field] ?? "";
    //   if (String(oldValue) !== String(newValue)) {
    //     updatedChangeHistory.push({
    //       title: `${field} updated`,
    //       Date: new Date().toISOString(),
    //       ChangeHistoryID: `${field}-${Date.now()}-${uuidv4()}`,
    //       ComputerID: uuidv4(),
    //       ChangedBy: createdBy,
    //       Field: field,
    //       OldValue: oldValue,
    //       NewValue: newValue,
    //     });
    //   }
    // });

    // // Assuming you have these variables available or derived:
    // const computerId = "CPT-123"; // Replace with actual ID
    // const inventoryTrackingString = "INV-456"; // Replace accordingly
    // const taskId = "1234";

    // const fields = {
    //   Title: `Asset - ${formData.name}`,
    //   ComputerID: computerId,
    //   Name: formData.name,
    //   Client: formData.client,
    //   Model: formData.model,
    //   SerialNumber: formData.serialNumber,
    //   InventoryTrackingNumber: inventoryTrackingString,
    //   Make: formData.make,
    //   CompanyAssetTag: formData.companyAssetTag,
    //   IsFaulty: true,
    //   IsRepaired: false,
    //   CreatedBy: createdBy,
    //   TaskID: taskId,
    // };

    // const repairDetails = {
    //   Title: ``,
    //   ComputerID: formData.computerId,
    //   ProblemDescription: formData.problemDescription,
    //   ResourceAssigned: formData.resourceAssigned,
    //   RepairDetails: formData.repairDetails,
    //   Status: formData.repairStatusType,
    //   Date: formData.date || new Date().toISOString(),
    //   Recommendations: formData.recommendations,
    //   CompanyAssetTag: formData.companyAssetTag,
    //   RepairID: "",
    // };

    // const repairHistory = [];

    // const submissionData = {
    //   fields,
    //   repairDetails,
    //   changeHistory: updatedChangeHistory,
    //   repairHistory,
    // };

    // // console.log("Submitted Payload:", submissionData);

    // setIsLoading(true);

    // try {
    //   let taskId = "";
    //   if (formData.resourceAssigned) {
    //     const technician = technicians.find(
    //       (t) => t.name === formData.resourceAssigned
    //     );

    //     if (technician) {
    //       const taskData = {
    //         Title: `Repair Computer: ${formData.name}`,
    //         AssignedTo: technician.userId,
    //         AssignedToName: createdBy,
    //         Description: `Serial Number: ${formData.serialNumber}\nClient: ${formData.client}`,
    //         Status: formData.repairStatusType,
    //         CreatedBy: createdBy,
    //         DateAssigned: new Date().toISOString(),
    //       };
    //       const taskResponse = await API.post("/tasks", taskData);
    //       taskId = taskResponse.data.taskId;
    //       // console.log(taskResponse.data);
    //     }
    //   }
    // } catch (error) {
    //   const errorMsg =
    //     error.response?.data?.message || "Failed to add computer";
    //   setErrorMessage(errorMsg);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
      <div className="w-full h-[450px] p-4 max-h-[80vh] max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col">
        <div className="">
          {/* Static Header */}
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
            Add New Asset
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>
        {/* Scrollable Content */}
        <form
          onSubmit={handleSubmit}
          className="flex-1 overflow-y-auto space-y-3"
        >
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Asset Name
              </label>
              <input
                id="name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label
                htmlFor="serialNumber"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Serial Number
              </label>
              <input
                id="serialNumber"
                type="text"
                name="serialNumber"
                value={formData.serialNumber}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label
                htmlFor="model"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Model
              </label>
              <input
                id="model"
                type="text"
                name="model"
                value={formData.model}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <div>
              <label
                htmlFor="make"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Make
              </label>
              <select
                id="make"
                name="make"
                value={formData.make}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">Select Make</option>
                {computerMakes.map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="client"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Client
              </label>
              <input
                id="client"
                type="text"
                name="client"
                value={formData.client}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label
                htmlFor="resourceAssigned"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Assigned Resource
              </label>
              <select
                id="resourceAssigned"
                name="resourceAssigned"
                value={formData.resourceAssigned}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">Select Technician</option>
                {technicians.map((technician) => (
                  <option key={technician.id} value={technician.name}>
                    {technician.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="repairStatusType"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Repair Status
              </label>
              <select
                id="repairStatusType"
                name="repairStatusType"
                value={formData.repairStatusType}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="In Repair">In Repair</option>
                <option value="Completed">Completed</option>
              </select>
            </div>
          </div>

          <div>
            <label
              htmlFor="companyAssetTag"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Company Asset Tag
            </label>
            <input
              id="companyAssetTag"
              type="text"
              name="companyAssetTag"
              value={formData.companyAssetTag}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          <div>
            <label
              htmlFor="problemDescription"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Problem Description
            </label>
            <textarea
              id="problemDescription"
              name="problemDescription"
              value={formData.problemDescription}
              onChange={handleChange}
              rows={4}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
        </form>
        {/* Action buttons */}
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-semibold transition duration-200 w-full sm:w-auto"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={!isFormValid || isLoading}
            className={`px-4 py-2 rounded-md text-sm font-semibold w-full sm:w-auto transition duration-200 ${
              !isFormValid || isLoading
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-800"
            }`}
          >
            {isLoading ? "Submitting..." : "Proceed"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddComputerForm;
